// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"8bfbed21","453":"bba174f7","455":"a5da1f86"}[chunkId] + ".chunk.js";
};